module.exports = __webpack_public_path__ + "c4998cb65c9695481c4c2e9e5708736b.png";